module.exports = __webpack_public_path__ + "static/media/unknown.3e107aa1.svg";